import { Container } from '@material-ui/core';
import styled from 'styled-components';

export const MainContainer = styled(Container)`
  display: flex;
  flex-wrap: wrap;
  gap: 1em;
`;
